// ============================================================
// Bloc « Bandeau de confiance » : éléments de rassurance
// (paiement sécurisé, livraison, support, garantie…).
// ============================================================

export interface TrustItem {
  icon: string;
  label: string;
}

export default function TrustBannerBlock({ items }: { items: TrustItem[] }) {
  if (!items || items.length === 0) return null;

  return (
    <div className="grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-4">
      {items.map((item, i) => (
        <div
          key={`${item.label}-${i}`}
          className="flex items-center gap-3 rounded-lg border border-background-200/70 bg-background-50 px-4 py-3"
        >
          <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-700">
            <i className={`${item.icon || 'ri-checkbox-circle-line'} text-base`}></i>
          </span>
          <span className="text-xs font-medium text-foreground-800 md:text-sm">{item.label}</span>
        </div>
      ))}
    </div>
  );
}